import { render, staticRenderFns } from "./StaffEvaluation.vue?vue&type=template&id=1dbf50a6&scoped=true&"
import script from "./StaffEvaluation.vue?vue&type=script&lang=js&"
export * from "./StaffEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./StaffEvaluation.vue?vue&type=style&index=0&id=1dbf50a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf50a6",
  null
  
)

export default component.exports